import React from 'react';
import { Button, Icon, Popconfirm, message } from "antd";
import { Link, hashHistory } from "react-router";
import connect from "react-redux/es/connect/connect";

import { subscribeChannelAction, deleteChannelsAction } from "../../../actions/channelsStoreActions";

const ChannelEditButton = ({
  currentChannel, 
  userClaims, 
  user, 
  subscribeOptions, 
  subscriptions,
  subscribeChannelAction,
  deleteChannelsAction,
  setStateHandler
}) => {
  const { messageType, error, subscribeLoading } = subscribeOptions;
  const { uid } = user;

  let persSubscriptions = [];
  let isOwnChannel = currentChannel.ownerId && currentChannel.ownerId.length > 0 &&
      currentChannel.ownerId.find(userId => userId === userClaims.user_id);
  let isSubscriber = false;

  const subscriptionsKey = subscriptions &&
    Object.keys(subscriptions).filter(key => key === uid);

  if (subscriptionsKey.length !== 0) {
    persSubscriptions = subscriptions[subscriptionsKey[0]];

    isSubscriber = persSubscriptions.filter(subscription => subscription === currentChannel.id).length !== 0;
  }

  const subscribeHandler = (id) => {
    if (!uid) {
      return setStateHandler({askForLogin: true});
    }

    let updPersSubscriptions = { [uid]: [ id ] };
    
    isSubscriber ?
      updPersSubscriptions = { [uid]: persSubscriptions.filter(subscription => subscription !== id) }
      : updPersSubscriptions = { [uid]: [...persSubscriptions, id] };
  
    subscribeChannelAction(updPersSubscriptions);
  
    if (messageType && messageType === 'success') {
      return message.success('Subscribtion Success');
    }
    if (messageType && messageType === 'error') {
      return message.error(error.message);
    }
  }

  const handleDeleteChannel = async (event, channel) => {
    event.preventDefault();
    const result = deleteChannelsAction(channel)
    result.then((res) => {
      if (res === 'success') {
        message.success(`Channel ${channel.title} - deleted`);
        hashHistory.push(`/profile`);
      }
    })
  }

  const cancel = () => {
    console.log('Canceled');
  }

  const btnSubscribeTitle = isSubscriber ? 'Unsubscribe' : 'Subscribe';

  if (isOwnChannel || userClaims.userType === 'Admin' ) {
    return (
      <React.Fragment>
        <Link to={`/Admin_configuration/${currentChannel.id}`}>
          <Button type="primary" htmlType="submit">
            Edit
          </Button>
        </Link>
        { userClaims.userType === 'Admin' && (
            <Button className="btn-danger">
              <Popconfirm 
                title={`Are you sure delete this channel - ${currentChannel.title}?`} 
                onConfirm={(event) => handleDeleteChannel(event, currentChannel)} 
                onCancel={cancel} 
                okText="Yes" 
                cancelText="No"
              >
                <a href="#">Delete</a>
              </Popconfirm>
            </Button>
          )
        }
      </React.Fragment>
      
    )
  } else {
    return (
      <React.Fragment>
        {
          subscribeLoading ? <Icon type="loading" style={{fontSize: '32px'}} /> : (
            <Button 
              type="primary" 
              htmlType="submit"
              onClick={() => subscribeHandler(currentChannel.id)}
            >
              {btnSubscribeTitle}
            </Button>
          )
        }
      </React.Fragment>
    )
  }
}

export default connect(
  null,
  { subscribeChannelAction, deleteChannelsAction }
)(ChannelEditButton);


// WEBPACK FOOTER //
// ./src/components/Modules/ChannelPageEditButton/index.js